module.exports = __webpack_public_path__ + "d5f6ba88427ff3765a9fa4ad231d3fd5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1080.webp.png
// module id = 374
// module chunks = 0